import React, { Component } from 'react';
import {getFacilityByStoreId} from 'actions';
import Error404 from "components/Errors/Error404";

export default class StoreIdRedirect extends Component {
    static async getInitialProps( { res, store: {dispatch}, query: {account_id, custom_id} } ) {
        try{
            const response = await dispatch(getFacilityByStoreId({account_id, custom_id}));

            const { facility: {facility_id = 'bad-id' }} = response;
            res.writeHead(301, { Location: `/facilities/${facility_id}` });
            res.end();

            return { response };
        }catch(err){
            res.statusCode = 404;
            return {};
        }
    }

    render() {
        return (
            <Error404/>
        );
    }
}
